'use client';
var S, e;
var SwanPathTypeEnum;
(S = SwanPathTypeEnum || (SwanPathTypeEnum = {})).hashed = "hashed", S.versioned = "versioned";
var SwanAssetFolders;
(e = SwanAssetFolders || (SwanAssetFolders = {})).FONTS = "FONTS", e.ICONS = "ICONS", e.ILLUSTRATIONS = "ILLUSTRATIONS", e.IMAGES = "IMAGES", e.JS = "JS", e.STYLES = "STYLES", e.FAVICONS = "FAVICONS", e.POLYFILLS = "POLYFILLS";

export { SwanAssetFolders, SwanPathTypeEnum };
